import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import firebaseApi from "../../apis/firebaseApi";
import TextToggle from "../common/TextToggle";
import { FrameContext } from "../../contexts/FrameContext";
import schedulingHelpers from "../../helpers/schedulingHelpers";
import useTranslations from "../../hooks/useTranslations";
import DayScheduleContainer from "../common/DayScheduleContainer";
import dateHelpers from "../../helpers/dateHelpers";

const AgentProfile = () => {
  const { source, companyId, agentId, brandId, appointmentData, sendMessage, user, isInFrame, refresh, settings } = React.useContext(FrameContext);
  const [agent, setAgent] = React.useState();
  const [agentLocations, setAgentLocations] = useState();
  const [company, setCompany] = useState();
  const [bookedSchedules, setBookedSchedules] = React.useState();
  const [isToday, setIsToday] = React.useState();
  const [isValid, setIsValid] = React.useState(true);
  const [isButtonsDisabled, setButtonsDisabled] = React.useState(false);
  const [selectedSchedule, setSelectedSchedule] = React.useState(null);

  //const radioRef = React.useRef();
  const isInitialLoad = React.useRef(true);
  let history = useHistory();

  let content = useTranslations();
  const [selectedRadio, setSelectedRadio] = useState(content.scheduleAppointment.todayButton);

  React.useEffect(() => {
    if (!companyId || !agentId) return;
    setIsToday(true);
    //radioRef.current = content.scheduleAppointment.todayButton;
    isInitialLoad.current = true;
    firebaseApi.getAgent(companyId, agentId, (data) => {
      if (data.exists) {
        let agentData = data.data();
        let agent = { ...agentData, id: data.id };
        setAgent(agent);
      }
    });

    if (source.source === "connect") {
      firebaseApi.getAgentById(source.agentId, (data) => {
        setAgent((agent) => {
          return { ...agent, slug: data.slug, name: data.name };
        });
        firebaseApi.updateAgent(companyId, agentId, {
          slug: data.slug,
          name: data.name,
        });
      });
    }

    firebaseApi.getPendingAgentSchedules(companyId, agentId, (data) => {
      let items = [];
      data.forEach((x) => items.push({ ...x.data(), id: x.id }));
      setBookedSchedules(items);
    });

    firebaseApi.getCompany(source.source, source.companyId).then((company) => {
      setCompany({ ...company.data(), id: company.id });
    });
  }, [companyId, agentId, refresh, source.source, source.agentId, source]);

  useEffect(() => {
    async function fetchTeams() {
      const teams = [];
      if (agent.locations && agent.locations.length > 0) {
        for (let i = 0; i < agent.locations.length; i++) {
          const locationId = agent.locations[i];
          const team = await firebaseApi.getLocationAsync(companyId, locationId);
          teams.push(team);
        }
      }

      setAgentLocations(teams);
    }

    if (agent) fetchTeams();
  }, [agent, companyId]);

  if (!agent || !bookedSchedules) return null;

  const onScheduleCallClick = (schedule) => {
    setIsValid(true);
    setButtonsDisabled(true);
    setSelectedSchedule(schedule);
    firebaseApi.getPendingAgentSchedules(companyId, agentId, (s) => {
      let isValid = true;
      s.forEach((x) => {
        let appointment = x.data();
        if (appointment.schedule.startTime >= schedule.schedule.startTime && appointment.schedule.endTime <= schedule.schedule.endTime) {
          isValid = false;
          setIsValid(false);
          setButtonsDisabled(false);
          setSelectedSchedule(null);
          window.scrollTo(0, 0);
        }
      });
      if (!isValid) return;

      // let testUser = {
      //   email: "testinFromLocal@gmail.com",
      //   emailOptIn: false,
      //   gmtOffset: 5,
      //   id: "user:1:109971",
      //   lang: "en",
      //   name: "testing from local",
      // };

      let data = {
        name: agent.name,
        agentId: agentId,
        schedule: schedule.schedule,
        user: user,
        createdDateTime: Math.floor(Date.now() / 1000),
      };
      if (agent.locationId) data.locationId = agent.locationId;
      if (brandId) data.brandId = brandId;
      if (appointmentData) data.appointmentData = appointmentData;

      // Implement a lock mechanism so that no 2 users are able to book the same slot.
      // create a collection scheduleLock -> contains the locked booked slot.
      // when creating schedule check if it is already locked, if not then create it else throw error.
      firebaseApi.createSchedule(companyId, data, (response) => {
        if (!response.success && response.error) {
          alert(response.error);
          setIsValid(false);
          setButtonsDisabled(false);
          setSelectedSchedule(null);
          return;
        } else {
          const docData = response.docData;
          firebaseApi.sendEmail(
            {
              ...data,
              source: source.source,
              companyId: source.companyId,
              brandId: brandId,
              scheduleId: docData.id,
              slug: agent.slug,
            },
            () => {
              history.push(`/appointment/${docData.id}`);
              setButtonsDisabled(false);
              setSelectedSchedule(null);
            },
            3
          );
        }
      });
    });
  };

  const onTextToggled = (isChecked, value) => {
    setSelectedRadio(value);
    setIsToday(value === content.scheduleAppointment.todayButton);
    //radioRef.current = value;
  };

  const getDays = () => {
    if (!agent.workHours) return null;
    let availableDays = [];
    let retAvailableDays = [];
    if (selectedRadio === content.scheduleAppointment.todayButton) availableDays = [new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())];
    else if (selectedRadio === content.scheduleAppointment.thisWeekButton) availableDays = schedulingHelpers.getAvailableDays(agent.workHours.data, 7, agent.gmtOffset);
    else availableDays = schedulingHelpers.getAvailableDays(agent.workHours.data, 7, agent.gmtOffset, true);

    // Added the functionality of unavailability option for the agent.
    // Unavailabilty can be defined in both agent level and company level.
    // When searching both of these needs to be merged together.
    let unavailableSchedule = [];
    if (agent && agent.settings && agent.settings.unavailableSchedule && agent.settings.unavailableSchedule.length > 0) {
      unavailableSchedule = [...agent.settings.unavailableSchedule];
    }

    if (company && company.settings && company.settings.unavailableSchedule && company.settings.unavailableSchedule.length > 0) {
      unavailableSchedule = [...unavailableSchedule, ...company.settings.unavailableSchedule];
    }

    if (agentLocations && agentLocations.length > 0) {
      agentLocations.forEach((team) => {
        if (team.settings && team.settings.unavailableSchedule && team.settings.unavailableSchedule.length > 0) {
          unavailableSchedule = [...unavailableSchedule, ...team.settings.unavailableSchedule];
        }
      });
    }

    if (unavailableSchedule.length > 0) {
      availableDays = availableDays.map((x) => new Date(x.getFullYear(), x.getMonth(), x.getDate(), 0, 0, 0, 0));
      retAvailableDays = availableDays.filter((x) => !unavailableSchedule.some((y) => x >= new Date(y.startDate * 1000) && x <= new Date(y.endDate * 1000)));
    } else {
      retAvailableDays = [...availableDays];
    }

    return retAvailableDays;
  };

  const onCancelClick = () => {
    sendMessage("scheduling_canceled");
  };

  const getBrokenDownSchedule = () => {
    return schedulingHelpers.getSchedulingBreakdown(agent.workHours, agent.gmtOffset, selectedRadio === content.scheduleAppointment.nextWeekButton);
  };

  const getDaySchedule = (day) => {
    // if the day is after the DST is applied and before the DST is ended and visitor's offset != after DST start offset
    // Add +1 to the user GMT as the DST is started after that
    // if the day is after the DST is ended and visitor's offset != after the DST ends offset
    // Add -1 to the user GMT as the DST is ended after that

    // As the code is run on the visitor browser, the dst transitions will be according to their machine's timezone
    const dstTransitionDates = schedulingHelpers.getDstTransitionDates();
    let userOffset = dateHelpers.getTimeZoneOffset();
    if (dstTransitionDates !== null && day > dstTransitionDates.start && day < dstTransitionDates.end && userOffset !== dstTransitionDates.afterStartOffset) {
      userOffset += 1;
    } else if (dstTransitionDates !== null && day > dstTransitionDates.end && userOffset !== dstTransitionDates.afterEndOffset) {
      userOffset -= 1;
    }

    const bufferTime = agent.settings && agent.settings.bufferTime ? parseInt(agent.settings.bufferTime) : 0;
    let times = schedulingHelpers.getAgentDayAvailability(day, agent, agent.duration, bookedSchedules, scheduleBreakdown, bufferTime, userOffset);

    times = schedulingHelpers.filterBookedSchedule(times, bookedSchedules);
    times = schedulingHelpers.removeCurrentTimesFromSchedule(times);

    let schedules = times
      ? times.map((x) => {
          return { schedule: x };
        })
      : null;
    let notAvailMsg = content.scheduleAppointment.agentNoAvailabilityThisWeek;

    if (selectedRadio === content.scheduleAppointment.todayButton) notAvailMsg = content.scheduleAppointment.agentNoAvailability;

    return (
      <DayScheduleContainer
        disabled={isButtonsDisabled}
        day={day}
        schedules={schedules}
        notAvailableMsg={notAvailMsg}
        onClick={onScheduleCallClick}
        selectedSchedule={selectedSchedule}
      />
    );
  };

  const getButtonStyles = () => {
    if (!settings || !settings.styles || (!settings.styles.buttonBorderRadius && !settings.styles.successColor)) return null;

    let styles = {};
    if (settings.styles.buttonBorderRadius) {
      styles.borderRadius = settings.styles.buttonBorderRadius;
    }

    if (settings.styles.primaryColor) {
      styles.backgroundColor = settings.styles.primaryColor;
    }

    if (settings.styles.secondaryTextColor) {
      styles.color = settings.styles.secondaryTextColor;
    }

    return styles;
  };

  const checkWeekAvailability = () => {
    const isNextWeek = selectedRadio === content.scheduleAppointment.nextWeekButton;
    let lastDayOfWeek = new Date().getDate() - (new Date().getDay() - 1) + 6;
    const lastDateOfWeek = dateHelpers.addDays(1, new Date(new Date().setDate(lastDayOfWeek)));

    let available = false;
    const daySpan = 60 * 60 * 24 * 1000;
    let checkDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
    for (let i = 0; i < 7; i++) {
      let times = schedulingHelpers.getAgentDayAvailability(
        !isNextWeek ? new Date(checkDate.getTime() + i * daySpan) : new Date(lastDateOfWeek.getTime() + i * daySpan),
        agent,
        agent.duration,
        bookedSchedules,
        scheduleBreakdown
      );
      if (times && times.length) available = true;
    }
    return available;
  };

  if (!agent || !bookedSchedules) return null;

  let days = getDays();
  let scheduleBreakdown = getBrokenDownSchedule();
  if (isInitialLoad.current && isToday) {
    isInitialLoad.current = false;
    let times = schedulingHelpers.getAgentDayAvailability(
      new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
      agent,
      agent.duration,
      bookedSchedules,
      scheduleBreakdown
    );
    if (!times || !times.length) {
      setIsToday(false);
      //radioRef.current = false;
    }
  }

  return (
    <div className="cts-ba-profile">
      <div className="cts-schedule">
        <h2>
          {content.common.scheduleAppointmentHeader}
          {content.common.scheduleAppointmentHeader2 ? (
            <>
              <br />
              {content.common.scheduleAppointmentHeader2}
            </>
          ) : null}
        </h2>
        <hr />
        <div className="cts-profile">
          <div className="cts-bold">{agent.name}</div>
        </div>
        <hr />
        <div>
          <TextToggle
            name="cts-schedule-name-toggle"
            r1Text={content.scheduleAppointment.thisWeekButton}
            r2Text={content.scheduleAppointment.todayButton}
            r3Text={content.scheduleAppointment.nextWeekButton}
            //value={!isTodayRef.current}
            value={selectedRadio}
            onChange={onTextToggled}
          />
        </div>
        {!isValid && (
          <>
            <div className="cts-error-text text-center">{content.scheduleAppointment.appointmentNotAvailable}</div>
            <hr />
          </>
        )}
        <div className="cts-schedule-days">
          {!days || days.length === 0 || !checkWeekAvailability() ? (
            <div className="text-center">{content.scheduleAppointment.agentNoAvailabilityThisWeek}</div>
          ) : (
            days.map((day) => getDaySchedule(day))
          )}
        </div>
      </div>
      {isInFrame() && (
        <div className="cts-footer-btn">
          <button style={getButtonStyles()} onClick={onCancelClick} type="button" className="">
            {content.common.cancelButton}
          </button>
        </div>
      )}
    </div>
  );
};

export default AgentProfile;
